import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAndClearRedirectPath } from '../utils/redirect';

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const userStr = searchParams.get('user');
    const error = searchParams.get('error');

    if (error) {
      toast.error(error);
      navigate('/login');
      return;
    }

    if (token && userStr) {
      try {
        JSON.parse(userStr);
        localStorage.setItem('token', token);
        localStorage.setItem('user', userStr);

        // Check if there's a saved redirect path
        const redirectPath = getAndClearRedirectPath();
        console.log('AuthCallback - redirect path:', redirectPath);

        // Force a page reload to update the authentication state
        const finalRedirect = redirectPath || '/dashboard';
        console.log('AuthCallback - final redirect to:', finalRedirect);
        window.location.href = finalRedirect;
        toast.success('Successfully logged in!');
      } catch (e) {
        toast.error('Failed to process login response');
        navigate('/login');
      }
    } else {
      toast.error('Invalid authentication response');
      navigate('/login');
    }
  }, [searchParams, navigate]);

  return (
    <div
      className='d-flex justify-content-center align-items-center'
      style={{ height: '100vh' }}
    >
      <div className='spinner-border text-primary' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </div>
    </div>
  );
};

export default AuthCallback;
